import React, {Component} from "react";
import * as PropTypes from "prop-types";
import "./Suggestion.css";

export default class Suggestion extends Component {
	constructor(props) {
		super(props);

		this.state = {
			isHovered: false,
                        isHighlighted: props.highlighted
		};

		this.formatAutocompleteSuggestion = this.formatAutocompleteSuggestion.bind(this);
		this.setIsHovered = this.setIsHovered.bind(this);
		this.buildResultHoverClass = this.buildResultHoverClass.bind(this);
	}

	formatAutocompleteSuggestion(suggestion) {
		const street = suggestion.street_line ? `${suggestion.street_line} ` : "";
		const secondary = suggestion?.secondary ? `${suggestion.secondary} ` : "";
		const entries = suggestion?.entries > 1 ? `(${suggestion.entries} more entries) ` : "";
		const city = suggestion?.city ? `${suggestion.city} ` : "";
		const state = suggestion?.state ? `${suggestion.state}, ` : "";
		const zip = suggestion?.zipcode ? `${suggestion.zipcode}` : "";

		return street + secondary + entries + city + state + zip;
	}

	setIsHovered(isHovered) {
		this.setState({isHovered});
	}

        setIsHighlighted(isHighlighted) {
            this.setState({isHighlighted});
        }

	buildResultHoverClass() {
            const className = "autocomplete--suggestion";
            if (this.state.isHovered || this.props.highlighted) {
                return className + " autocomplete--suggestion-hover";
            } else {
                //return this.state.isHovered ? className + " autocomplete--suggestion-hover" : className;
                return className;
            }
	}

    render() {
      return (
        <div
          aria-selected={this.state.isHovered || this.props.highlighted}
          className={this.buildResultHoverClass()}
          onMouseDown={(e) => { e.preventDefault(); this.props.selectSuggestion(this.formatAutocompleteSuggestion(this.props.suggestion)); }}
          onMouseEnter={() => this.setIsHovered(true)}
          onMouseLeave={() => this.setIsHovered(false)}
        >
         {this.formatAutocompleteSuggestion(this.props.suggestion)}
        </div>
      );
    }
}

Suggestion.propTypes = {
	suggestion: PropTypes.any,
	selectSuggestion: PropTypes.func.isRequired,
};

